import React, {Component} from 'react'
import { connect } from 'react-redux'

// Elements
import Row from '../../../shared/elements/row'
import Col from '../../../shared/elements/col'
import Panel from '../../../shared/elements/panel'
import Switch from '../../../shared/elements/switch'

// Actions
import { getSupportAccess, saveSupportAccess } from '../../../actions/settings'

// Utils
import { translation } from '../../../utils/helpers'
import Label from '../../../shared/elements/label'

class SupportAccess extends Component {
  constructor (props) {
    super(props)
    this.state = {
      SupportAccessInfo: {
        SupportTeams: [],
        AllowSupportAccess: false
      }
    }
    this.onChange = this.onChange.bind(this)
  }

  componentDidMount () {
    this.getSupportAccess()
  }

  getSupportAccess () {
    this.props.getSupportAccess(this.props.auth.user.ShopId).then((res) => {
      this.setState({
        SupportAccessInfo: res.data
      })
    }, (err) => {
      console.log(err)
    })
  }

  saveSupportAccess () {
    let supportaccessInfo = {...this.state.SupportAccessInfo}
    this.props.saveSupportAccess(supportaccessInfo).then((res) => {
      this.setState({
        SupportAccessInfo: res.data
      })
    }, (err) => {
      console.log(err)
    })
  }
  onChange (e) {
    let value = e.target.checked
    this.setState({
      [e.target.name]: value,
      SupportAccessInfo: {
        ...this.state.SupportAccessInfo,
        AllowSupportAccess: value
      }
    }, () => {
      this.saveSupportAccess()
    })
  }

  render () {
    let supportTeams = this.state.SupportAccessInfo.SupportTeams
    let allowSupportAccess = this.state.SupportAccessInfo.AllowSupportAccess
    const renderSupportTeam = (val, key) => {
      return (
        <Label size='m' key={key}>{val.ChainName}</Label>
      )
    }
    return (
      <Row>
        <Col>
          <Panel title={translation('17967')}>
            <Switch labelText={translation('17968')} helpText={translation('17969')} checked={allowSupportAccess} name='SupportAccess' onChange={this.onChange} />
            <Label size='m'>{translation('18039')}</Label>
            <br />
            {supportTeams.map(renderSupportTeam)}
          </Panel>
        </Col>
      </Row>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  getSupportAccess,
  saveSupportAccess
})(SupportAccess)



// WEBPACK FOOTER //
// ./src/app/pages/Settings/SupportAccess/index.js